import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHelperService } from '../../utilities/http-helper/http-helper.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(private http: HttpClient, private httpHelper: HttpHelperService) { }

  createCard(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrlSubs('/api/Stripe/CreateCard');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }

  createSubscription(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrlSubs('/api/Subscription/CreateSubscription');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }

  updateAutoRenewal(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrlSubs('/api/Stripe/UpdateAutoRenewal');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put(apiUrl, data, requestOptions);
  }

  subscribeTrial(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrlSubs('/api/Subscription/FreeTrialPeriod');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }
  
  getPlanById(paramsReq): Observable<any> {
    let params = new HttpParams()
    .set('id', paramsReq)
    const apiUrl = this.httpHelper.getApiUrlSubs('/api/Plans/GetPlanDetailsById');
    return this.http.get(apiUrl, { params: params });
  }

  updateBillingAddress(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrlSubs(`/api/Subscription/UpdateBillingAddress`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.put<any>(apiUrl, data, requestOptions);
  }

  zipCodeValidation(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl('/api/Locations/ValidateZipCode');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }
  createMultipleLocation(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl('/api/Locations/CreateMultipleLocations');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }
  createMultipleStylist(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl('/api/Stylists/CreateMultipleStylist');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }

  promoCodeValidation(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrlSubs('/api/Offers/PromoCodeValidation');
    // const requestOptions: Object = {
    //   responseType: 'text'
    // }
    return this.http.post(apiUrl, data);
  }

  storeRpDetails(data: any): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrlSubs('/api/RazorPay/StoreRpSubscriptionDetails');
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data,requestOptions);
  }
}
